import React from "react";
import { graphql, useStaticQuery, Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import roads from "../../images/park_map_roads.svg"
import droppin from "../../images/map_pin.svg"
import Prose from "../utility/prose";

const ParkMap = () => {
    const data = useStaticQuery(graphql`
        query {
            basemap: file(relativePath: {eq: "park_map_base-optimized.png"}) {
                id
                childImageSharp {
                    gatsbyImageData(
                        width: 2048
                        placeholder: BLURRED
                        formats: [AUTO, WEBP]
                    )                    
                }
            }
        }
  `)

    let pins = [
        { x: '51%', y: '28.2%', dest: '/little-elm-pond', name: 'Little Elm Pond' },
        { x: '63.7%', y: '35.4%', dest: '/lakeline-oaks-park-and-pavilion', name: 'Lakeline Oaks Park & Pavilion' },
        { x: '44.9%', y: '37.5%', dest: '/madeline-loop-pond', name: 'Madeline Loop Pond' },
        { x: '52.7%', y: '38.5%', dest: '/old-mill-pocket-park', name: 'Old Mill Pocket Park' },
        { x: '41.7%', y: '43.8%', dest: '/sun-chase-park', name: 'Sun Chase Park' },
        { x: '36%', y: '54.3%', dest: '/anderson-mill-west-park-and-pavilion', name: 'Anderson Mill West Park & Pavilion' },
        { x: '23.1%', y: '56.5%', dest: '/anderson-mill-west-pond', name: 'Anderson Mill West Pond' },
        { x: '44.9%', y: '56.9%', dest: '/aster-park', name: 'Aster Park' },
        { x: '40.9%', y: '58.5%', dest: '/aster-pass-pond', name: 'Aster Pass Pond' },
        { x: '62.9%', y: '61.5%', dest: '/hatch-pond', name: 'Hatch Pond' },
        { x: '28.5%', y: '62.1%', dest: '/london-lane-pond', name: 'London Lane Pond' },
        { x: '22.6%', y: '62.6%', dest: '/cashell-wood-pond', name: 'Cashell Wood Pond' },
        { x: '25.1%', y: '63%', dest: '/volente-hills-park', name: 'Volente Hills Park' },
        { x: '23.4%', y: '69.7%', dest: '/vestavia-pond', name: 'Vestavia Pond' },
    ]

    return (
        <div className="mx-auto mb-14">
            <div className="relative overflow-hidden rounded-3xl">
            <div className="base-map-container">
                <GatsbyImage image={data.basemap.childImageSharp.gatsbyImageData} />
            </div>
            <img className="absolute top-0 left-0 w-full h-auto m-0 drop-shadow-lg" src={roads} alt="" />
            <div className="top-0 left-0 absolute w-full h-full">
                {pins.map(pin => (
                    <Link className="absolute mt-[-43px] ml-[-15px] group" style={{ left: pin.x, top: pin.y }} to={`${pin.dest}`}><img className="w-8 drop-shadow-lg" src={droppin} alt={pin.name} />
                        <div className="z-10 w-40 bg-neutral-700 text-white block absolute -ml-20 left-[50%] text-center top-16 py-1 px-2 rounded-2xl transition-opacity opacity-0 group-hover:opacity-100 pointer-events-none">{pin.name}</div>
                    </Link>
                ))}
            </div>
            </div>
        </div>
    )
}

export default ParkMap
